import { render, staticRenderFns } from "./CRUDEmployee.vue?vue&type=template&id=482094f7&scoped=true&"
import script from "./CRUDEmployee.vue?vue&type=script&lang=js&"
export * from "./CRUDEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482094f7",
  null
  
)

export default component.exports